<template>
  <div>
    <b-modal
      size="lg"
      id="create"
      title="LANÇAR SERVIÇO"
      hide-footer
      no-close-on-backdrop
    >
      <new-service :resident="resident" @success="paginate" />
    </b-modal>
    <b-modal
      title="DETALHES DO SERVIÇO"
      id="details"
      size="lg"
      hide-footer
      no-close-on-backdrop
    >
      <details-service :service="service" />
    </b-modal>
    <b-modal
      title="EDITAR LANÇAMENTO"
      id="edit"
      hide-footer
      no-close-on-backdrop
    >
      <edit-service :service="service" @success="paginate" />
    </b-modal>
    <div class="row">
      <div class="col-md-12 text-right">
        <v-btn @click="$bvModal.show('create')" class="btn-two-add">
          <i class="fas fa-plus mr-2 text-twenty"></i>LANÇAR SERVIÇO
        </v-btn>
      </div>
      <div class="col-md-3">
        <select
          class="form-control form-control-sm"
          v-model="service_id"
          @change="handleFilter"
        >
          <option :value="null">TODOS</option>
          <option v-for="(item, key) in services" :key="key" :value="item.id">
            {{ item.description }}
          </option>
        </select>
      </div>
      <Filters @paginate="handleFilters" :loading="loading" />
      <div
        class="col-md-12 pt-0"
        v-if="data.length > 0 && selectedIds.length > 1"
      >
        <confirmation-dialog
          headerClass="modal-header-i"
          message-title="Deseja realmente excluir os lançamentos selecionados?"
          message-body=""
          openText="EXCLUIR SELECIONADOS"
          open-class="btn-delete"
          open-left-icon="fa-trash"
          @yes="deleteServices"
          :disabled="loadingDelete"
          :loading="loadingDelete"
          small
        />
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div v-show="data.length === 0" class="v-clean p-5">
        <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
      </div>
      <v-data-table
        show-select
        v-model="selected"
        v-show="data.length > 0"
        dense
        :headers="headers"
        :items="data"
        :footer-props="{
          'items-per-page-options': [25, 50, 75, 100],
          'items-per-page-text': 'Mostrar',
        }"
        :options.sync="options"
        :server-items-length="total"
      >
        <template v-slot:[`item.status`]="{ item }">
          <small>FATURAMENTO PENDENTE</small>
          <v-icon class="ml-2" small color="orange">
            mdi-information-outline
          </v-icon>
          <input type="hidden" :value="item.status" />
        </template>
        <template v-slot:[`item.date`]="{ item }">
          {{ moment(item.date).format("DD/MM/YYYY") }}
        </template>
        <template v-slot:[`item.service_charge_type`]="{ item }">
          {{ item.service_charge_type_name }}
        </template>
        <template v-slot:[`item.quantity`]="{ item }">
          {{ item.quantity }}
        </template>
        <template v-slot:[`item.service`]="{ item }">
          {{ item.service_description }}
        </template>
        <template v-slot:[`item.details`]="{ item }">
          <v-btn x-small class="btn-primary m-1" @click="handleDetails(item)">
            <i class="fas fa-eye mr-2"></i>DETALHES
          </v-btn>
          <v-btn
            v-if="item.status == 1"
            x-small
            class="btn-edit m-1"
            @click="handleEdit(item)"
          >
            <i class="fas fa-edit mr-2"></i>EDITAR
          </v-btn>
          <confirmation-dialog
            v-if="item.status == 1"
            x_small
            message-title="EXCLUIR?"
            message-body="Deseja realmente excluir o lançamento do serviço?"
            open-class="btn-delete m-1"
            open-left-icon="fa-trash"
            open-text="EXCLUIR"
            @yes="deleteService(item.id)"
            :disabled="loadingDelete"
            :loading="loadingDelete"
          />
        </template>
      </v-data-table>
    </b-overlay>
    <ErrorsMessages :errors="errors" />
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import ConfirmationDialog from "../../Components/ConfirmationDialog.vue";

import Filters from "../../Components/Filters.vue";

import NewService from "./service/new.vue";
import DetailsService from "./service/details.vue";
import EditService from "./service/edit.vue";

import api from "../../../services/api";

import toast from "../../../lib/ToastNotification";

import routes from "../../../routes";

import { formatPrice } from "../../../lib/format";

import moment from "moment";

export default {
  name: "Launch",

  components: {
    ErrorsMessages,
    ConfirmationDialog,
    Filters,
    NewService,
    DetailsService,
    EditService,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      month: moment().format("YYYY-MM"),
      dayMonthYear: "month",

      selected: [],
      selectedIds: [],

      status: 1,
      service_id: null,
      resident_id: "",

      total: 0,
      options: {},

      headers: [
        { text: "STATUS", value: "status", sortable: false },
        { text: "DATA DO SERVIÇO", value: "date", sortable: false },
        { text: "SERVIÇO", value: "service", sortable: false },
        {
          text: "TIPO DE COBRANÇA",
          value: "service_charge_type",
          sortable: false,
        },
        { text: "QUANTIDADE", value: "quantity", sortable: false },
        { text: "AÇÕES", value: "details", sortable: false },
      ],

      data: [],

      services: [],

      service: {},

      loading: false,
      loadingDelete: false,

      errors: [],
    };
  },

  watch: {
    selected() {
      this.selectedIds = this.selected.map(({ id }) => id);
    },

    options: {
      handler() {
        this.paginate();
      },
    },

    $route(to, from) {
      if (JSON.stringify(to.query) !== JSON.stringify(from.query)) {
        let { nav, create } = to.query;

        if (nav == "service" && create == "true") {
          this.$bvModal.show("create");
        }
      }
    },
  },

  created() {
    this.retrieve();
  },

  mounted() {
    let { nav, create } = this.$router.history.current.query;

    if (nav == "service" && create == "true") {
      this.$bvModal.show("create");
    }
  },

  methods: {
    moment,
    formatPrice,

    retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.paginate();
      this.getServices();
    },

    async getServices() {
      try {
        const response = await api.get("/rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.services = services;
        }
      } catch (error) {
        console.log(error);
      }
    },

    handleDetails(service) {
      this.service = service;
      this.$bvModal.show("details");
    },

    handleEdit(service) {
      this.service = service;
      this.$bvModal.show("edit");
    },

    handleFilters(filters) {
      let { month, dayMonthYear } = filters;

      this.month = month;
      this.dayMonthYear = dayMonthYear;

      this.paginate();
    },

    handleFilter() {
      this.options.page = 1;
      this.paginate();
    },

    async paginate() {
      try {
        this.loading = true;

        let { resident_id, service_id, status, month, dayMonthYear } = this;

        const { page, itemsPerPage } = this.options;

        let params = {
          resident_id,
          service_id,
          page,
          itemsPerPage,
          status,
          month,
          dayMonthYear,
        };

        const response = await api.get("/rest-home/resident/services", {
          params,
        });

        const { error, errors, data, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.data = data;
          this.total = total;
          this.$bvModal.hide("filter");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async deleteService(id) {
      try {
        this.loadingDelete = true;

        let data = { id };

        let response = await api.delete("/rest-home/resident/service", {
          data,
        });

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.paginate();
        }

        this.loadingDelete = false;
      } catch (error) {
        this.loadingDelete = false;
        console.log(error);
      }
    },

    async deleteServices() {
      try {
        this.loadingDelete = true;

        let { selectedIds } = this;

        let data = { ids: selectedIds };

        let response = await api.delete("/rest-home/resident/services", {
          data,
        });

        let { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.selected = [];
          this.selectedIds = [];
          this.paginate();
        }

        this.loadingDelete = false;
      } catch (error) {
        this.loadingDelete = false;
        console.log(error);
      }
    },
  },
};
</script>
